<div class="title-bar">
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item">
				<a href="javascript:void(0)" routerLink="..">
					<fa-icon [icon]="ac.sectionIcons.mysettings" class="cp-user-nav-item me-1" size="sm">
					</fa-icon>
					My Settings
				</a>
			</li>
			<li class="breadcrumb-item active" aria-current="page">
				Update Settings
			</li>
		</ol>
	</nav>
</div>

<form [formGroup]="theForm" autocomplete="false" *ngIf="!!user">
	<div class="cp-general-width-limit">
		<div *ngIf="loading || saving" style="text-align: center;">
			<app-loading-spinner></app-loading-spinner>
		</div>

		<div class="form-group">
			<label for="name">Name*</label>
			<input type="text" id="name" formControlName="name" class="form-control" />
		</div>

		<div class="form-group">
			<label for="title">Title</label>
			<input type="text" id="title" formControlName="title" class="form-control" />
		</div>

		<div *ngIf="showFavorite" class="form-group">
			<label for="starPref">Icon for Favorites</label><br />
			<span *ngFor="let fav of ac.favoriteIcons; let i = index" (click)="selectFavorite(fav)" class="p-1 m-0"
				style='font-size: 1.5rem' [ngClass]="{'cp-selected-primary': fav === starPref}" [ngbTooltip]="fav">
				<fa-icon [icon]="['fas', fav ]"></fa-icon>
			</span>
		</div>

		<!-- <div class="form-group mb-2 small">* Required</div>

		<div class="form-group" *ngIf="!saving">
			<button class="btn btn-primary me-1" type="submit" [disabled]="!theForm.valid">
				<fa-icon [icon]="['fas', 'check']"></fa-icon> Save
			</button>
			<button class="btn btn-outline-secondary" type="button" (click)="onCancel()">
				<fa-icon [icon]="['fas', 'times']"></fa-icon> Cancel
			</button>
		</div> -->
	</div>

	<div class="cp-form-padding"></div>

	<div *ngIf="!loading && theForm" class="cp-form-buttons">
		<div class="cp-form-buttons-inner">
			<button class="btn btn-primary me-1" type="button" (click)="onSubmit()" [disabled]="!theForm.valid || saving">
				<fa-icon [icon]="ac.actionIcons.submit"></fa-icon> Save
			</button>
			<button class="btn btn-outline-secondary" type="button" (click)="onCancel()" [disabled]="saving">
				<fa-icon [icon]="ac.actionIcons.cancel"></fa-icon> Cancel
			</button>

			<span class="gj-75 ps-2">* Required</span>
		</div>
	</div>

</form>